<div class="summary-details" *ngIf="cart">
  <div class="summary-row">
    <div *ngIf="(isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null" class="summary-label">
      {{
        'cart.orderSummary.subtotal'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    <div class="summary-amount" *ngIf="isCheckoutPage || !showSrp">
      {{ cart.subTotal?.formattedValue }}
    </div>
  </div>
  <div class="summary-row">
    <div *ngIf="(isDiscountRelatedCustomTranslationsEnabled$ | async) !== null" class="summary-label">
      {{
        'cart.orderSummary.discount'
          | cxTranslate
            : {
                context: setCustomContext(
                  isDiscountRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    <div class="summary-amount" *ngIf="isCheckoutPage || !showSrp">
      {{ cart.orderDiscounts?.formattedValue }}
    </div>
  </div>
  <div
    class="summary-row"
    [ngClass]="(showActiveSnahCountry$ | async) ? 'hasGap' : ''"
    *ngIf="showDeliveryFee$ | async"
  >
    <div class="summary-label js-delivery-fee">
      {{ 'cart.orderSummary.estimatedShipping' | cxTranslate }}
    </div>
    <div
      class="summary-amount js-delivery-cost"
      [attr.data-value]="cart.deliveryCost?.value"
      *ngIf="isCheckoutPage || !showSrp"
    >
      <ng-container *ngIf="!(showActiveSnahCountry$ | async); else snahCountries">
        <span *ngIf="!(showDeliveryFeeCustomMsg$ | async) && (showDeliveryFeeCustomMsg$ | async) !== null">{{
          cart?.deliveryCost?.value > 0
            ? cart?.deliveryCost?.formattedValue
            : ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
        }}</span>
      </ng-container>
      <ng-template #snahCountries>
        <span *ngIf="!(showDeliveryFeeCustomMsg$ | async) && (showDeliveryFeeCustomMsg$ | async) !== null">{{
          hasFreeFreight(cart?.freeFreight, cart?.freeDeliveryModes)
            ? ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
            : ('myAccount.orderDetails.orderTotalSummary.calculateFee' | cxTranslate)
        }}</span>
      </ng-template>
      <span
        *ngIf="showDeliveryFeeCustomMsg$ | async"
        [innerHTML]="
          'cart.orderSummary.deliveryFeeCustomMsg' | cxTranslate : { context: (isMobile$ | async) ? 'mobile' : '' }
        "
      ></span>
    </div>
  </div>
  <div class="summary-row" *ngIf="showSalesTax$ | async">
    <div *ngIf="(isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null" class="summary-label">
      {{
        'cart.orderSummary.salesTax'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    <div class="summary-amount" *ngIf="isCheckoutPage || !showSrp">
      {{ isCheckoutPage ? getCart?.totalTax?.formattedValue : cart?.totalTax?.formattedValue }}
    </div>
  </div>
  <!-- Total Summary -->
  <div class="summary-row summary-total">
    <div *ngIf="(isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null" class="summary-label">
      {{
        'cart.orderSummary.total'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    <div class="summary-amount" *ngIf="isCheckoutPage || !showSrp">
      <ng-container *ngIf="hideSalesTaxInCart$ | async; else totalPriceWithTaxTemplate">{{
        cart.totalPrice?.formattedValue
      }}</ng-container>
      <ng-template #totalPriceWithTaxTemplate>{{
        isCheckoutPage ? getCart?.totalPriceWithTax?.formattedValue : cart?.totalPriceWithTax?.formattedValue
      }}</ng-template>
    </div>
  </div>
  <div class="summary-row gst" *ngIf="showGstMsg$ | async">
    {{ 'checkout.group.gst.' + (taxLabel$ | async) | cxTranslate }}
  </div>
  <div class="summary-row freight" *ngIf="(showActiveSnahCountry$ | async) && freightPrice && freightPrice !== '$0'">
    <mat-icon svgIcon="freight-icon"></mat-icon>
    <span>{{ 'checkout.group.customFreight.freight' | cxTranslate : { freightLevel: freightPrice } }}</span>
  </div>
</div>
